import React, { useState, useEffect } from "react";
import "./WeatherForecast.css";
import WeatherForecastDay from "./WeatherForecastDay";
import axios from "axios";

export default function WeatherForecast(props){
    let [loaded, setLoaded] = useState(false);
    let [forecast, setForecast] = useState(null);

    useEffect(()=>{
        setLoaded(false);
    }, [props.coordinates]);
    
    function handleResponse(response){
        setForecast(response.data.daily);
        setLoaded(true);
    }
    
    if(loaded) {
        return (
        <div className = "WeatherForecast">
            <div className = "row">
                {forecast.map(function (dailyForecast, index){
                    if(index<5){
                        return (
                            <div className = "col" key={index}>
                                <WeatherForecastDay data={dailyForecast}/>
                            </div>
                        );
                    } else {
                        return null;
                    }
                })};
            </div>
        </div>
    );
    } else {
        const apiKey = '7e2d6c3d38a855b033f6e213b1c9eca4';
        let longitude = props.coordinates.lon;
        let latitude = props.coordinates.lat;
        let apiURL = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;
        
        axios.get(apiURL).then(handleResponse);
        return null;
    }
    
}